import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Stack, Box} from 'views/components';
import {MarkdownViewer, Translate, translate} from 'views/module';

import {getChangedByActor} from '../changedBy';

const DeactivationDetails = (props) => {
  const {deactivatedData, changedByLabel} = props;

  const reasonBlob = deactivatedData?.description?.blob;

  // Legacy records were deactivated before the actor was recorded, so the actor can be missing entirely.
  // Schedule-FE only stores changedByRn, so whether it was a person or an internal service comes from its prefix.
  const changedByRn = deactivatedData?.changedByRn;
  const changedBy = changedByLabel || changedByRn;
  const changedByActor = getChangedByActor(changedByRn);

  return (
    <Stack spacing={1}>
      <Typography fontWeight="bold" fontSize={'14px'}>
        <Translate expression='schedule.eventDetail.EventTimelineSection.Deactivation.Reason' />
      </Typography>
      {
        reasonBlob &&
        <MarkdownViewer
          value={reasonBlob}
          truncate={true}
        />
      }
      {
        !reasonBlob &&
        <Typography color="text.secondary" fontSize={'14px'}>
          <Translate expression='schedule.eventDetail.EventTimelineSection.Deactivation.NoReason' />
        </Typography>
      }
      <Stack direction='row' spacing={1} alignItems='center' flexWrap='wrap'>
        <Typography color="text.secondary" fontSize={'14px'}>
          {
            changedBy &&
            <Translate
              expression='schedule.eventDetail.EventTimelineSection.Deactivation.ChangedBy'
              substitute={{changedBy}}
            />
          }
          {
            !changedBy &&
            <Translate expression='schedule.eventDetail.EventTimelineSection.Deactivation.ChangedByUnknown' />
          }
        </Typography>
        {
          changedByActor &&
          <Box
            sx={{
              border: '1px solid',
              borderColor: 'grey.500',
              borderRadius: 1,
              color: 'grey.700',
              px: 0.5,
              width: 'fit-content',
            }}
          >
            <Typography variant="caption" sx={{fontWeight: 500, lineHeight: 1}}>
              {translate(`schedule.eventDetail.EventTimelineSection.Deactivation.ChangedByActor.${changedByActor}`)}
            </Typography>
          </Box>
        }
      </Stack>
    </Stack>
  );
};

DeactivationDetails.propTypes = {
  deactivatedData: PropTypes.shape({
    action: PropTypes.string,
    changedByRn: PropTypes.string,
    timeDeactivated: PropTypes.string,
    description: PropTypes.shape({
      blob: PropTypes.string,
      editorType: PropTypes.string,
    }),
    newRescheduleEventRn: PropTypes.string,
  }),
  changedByLabel: PropTypes.string,
};

export default DeactivationDetails;
